module.exports = __webpack_public_path__ + "static/media/back-oval.5ffeec8e.svg";